export const applianceTypes = {
    'lighting': {
        'switching': 'RFSAI-62B-SL',
        'dimming': 'RFDEL-71B-SL',
        "daliDimming": 'RFDALI-04B-SL'
    },
    'curtains': {
        'curtains': 'RFJA-32B-SL'
    },
    'all': {
        'switching': 'RFSAI-62B-SL',
        'dimming': 'RFDEL-71B-SL',
        'curtains': 'RFJA-32B-SL'
    }
}